<template>
  <div v-if="reports">
    <a-card title="Geolocation Information">
      <a-row>
        <a-col :span="5">
          <div class="wemail__geolocation-progress">
            <h3>
              <strong>{{reports.sent}} &nbsp;</strong>
              <span>Recievers</span>
            </h3>
          </div>
        </a-col>
        <a-col :span="6">
          <div class="wemail__geolocation-progress">
            <a-progress
              :width="80"
              type="circle"
              :percent="calculatePercentage(reports.unique_opened)"
            />
            <h3>
              {{reports.unique_opened}}
              <span>Opens</span>
            </h3>
          </div>
        </a-col>

        <a-col :span="6">
          <div class="wemail__geolocation-progress">
            <a-progress
              :width="80"
              type="circle"
              :percent="calculatePercentage(reports.unique_clicked)"
            />
            <h3>
              {{reports.unique_clicked}}
              <span>Clicks</span>
            </h3>
          </div>
        </a-col>

        <a-col :span="7">
          <div class="wemail__geolocation-progress">
            <a-progress
              :width="80"
              type="circle"
              :percent="calculatePercentage(reports.unsubscribed)"
            />
            <h3>
              {{reports.unsubscribed}}
              <span>Unsubscribed</span>
            </h3>
          </div>
        </a-col>
      </a-row>
      <a-row>
        <h3 class="ml-15">
          Total Recipients:
          <strong>{{reports.total}}</strong>
          <small :style="{ marginLeft: '10px', color: '#827878' }">({{reports.sent}} sent)</small>
        </h3>
      </a-row>
      <hr>
      <a-row>
        <h3 class="ml-15 mt-12">Total Clicks: {{reports.clicked}}</h3>
      </a-row>
      <hr>
      <a-row>
        <h3 class="ml-15">Geolocation</h3>
        <a-row class="ml-15">
          <a-col :span="4" v-for="(subscriber,index) in reports.subscribers" :key="index">
            <a-tooltip placement="top">
              <template slot="title">
                <span>{{subscriber.countryCode}}</span>
              </template>
              <span
                v-if="subscriber.countryCode !== 'Unknown'"
                :style="{fontSize:'1.5rem'}"
                :class="`flag-icon flag-icon-${flagLetterFilter(subscriber.countryCode)}`"
              ></span>
              <span v-else class="flag-icon-unknown">Others</span>
            </a-tooltip>
            <span
              :style="{fontSize:'1.5rem', marginLeft: '6px'}"
            >{{percentageRound(subscriber.percentage)}}%</span>
          </a-col>
        </a-row>
      </a-row>
    </a-card>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      reports: "campaigns/countrywisestats"
    })
  },
  methods: {
    calculatePercentage(val) {
      if (this.reports.sent !== 0) {
        return Math.round((val * 100) / this.reports.sent);
      } else {
        return 0;
      }
    },
    percentageRound(val) {
      return parseFloat(val).toFixed(2);
    },
    flagLetterFilter(upper) {
      return upper.toLowerCase();
    }
  }
};
</script>

<style>
.wemail__geolocation-progress {
  display: flex;
  align-items: center;
  min-height: 120px;
}
.wemail__geolocation-progress h3 {
  margin-left: 20px;
}
.wemail__geolocation-progress h3:first-child {
  margin-left: 15px;
}
.flag-icon-unknown {
  font-size: 1.5em;
  color: orange;
  font-weight: normal;
}
hr {
  height: 2px;
  border: 0;
  background: #f1f1f1;
}
.ml-15 {
  margin-left: 15px;
}
.mt-12 {
  margin-top: 12px;
}
</style>
